"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinesweeperSquareMobileSizeOptions = void 0;
exports.MinesweeperSquareMobileSizeOptions = {
    EASY: 14.58,
    NORMAL: 19.44,
    HARD: 35,
};
